import { Button } from '@heroui/react'
import React from 'react'
import { MenuIcon } from '../../utils/svgIcons'
import BreadcrumbSearch from "../../utils/BreadcrumbSearch"; // Import the search component
import Profile from '../../pages/Profile/Profile';
import { useAuth } from '../../hooks/useAuth';
import usePageTitle from '../../utils/usePageTitle';

function Header({ toggleSidebar, allowedRoutes, setIsMobileMenuOpen }) {
  const { user } = useAuth();
  const pageTitle = usePageTitle();

  return (
    <div className='w-full bg-white rounded-[18px] shadow-global p-3 px-6'>
      <div className="wrapper flex justify-between items-center gap-5">
        <div className="togglebutton flex items-center gap-3">
          <Button onPress={toggleSidebar} className='min-w-0 justify-items-center h-12 w-12 p-0 rounded-full Desktop hidden xl:block' variant='none'>
            <MenuIcon />
          </Button>
          <Button onPress={() => setIsMobileMenuOpen(true)} className='min-w-0 h-12 w-12 p-0 rounded-full "Mobile block xl:hidden' variant='none'>
            <MenuIcon />
          </Button>
          <div className="">{pageTitle}</div>
        </div>
        <div className="flex justify-center profile gap-5">
          <BreadcrumbSearch allowedRoutes={allowedRoutes} />
          <Profile user={user} />
        </div>
      </div>
    </div>
  )
}

export default Header